<template>
    <div v-if="isAdmin" id="fichebu-audit-data-management">
        <as-container gutters="0">
            <div class="grid grid-nogutter mb-3">
                <div class="flex w-100">
                    <as-title :title="$t('ficheBu.audit_data_list.title')" :size="1"></as-title>
                    <div class="ml-auto">
                        <Button style="width: 240px" :label="$t('ficheBu.audit_data_list.new_audit_data_button_label')"
                            class="button-default" @click="showModalAuditDataForm" />
                    </div>
                </div>
            </div>
            <ProgressBar v-if="isAuditDataLoading" mode="indeterminate" style="height: 6px" class="mb-3" />
            <audit-data-list v-else :auditDatas="auditDatas" :entreprises="entreprises" @onRowClick="editAuditData"
                @onDelete="onShowDeleteAuditDataModal" />
        </as-container>
    </div>
    <as-modal :isVisible="showAuditDataForm" class="reduced-form-modal">
        <auditData-form :key="currentAuditDataKey" :entreprises="entreprises" :auditDatas="auditDatas"
            :auditData="currentAuditData" :isSending="isSending" @onClose="closeModalAuditDataForm"
            @onSubmit="saveAuditData" />
    </as-modal>
    <as-confirm-modal :isVisible="showDeleteAuditDataModal" :modalMessage="$t('confirm_modal.delete_message')"
        @onConfirm="deleteAuditData" @onCancel="deleteAuditDataCancel" />
</template>
<script>
import localeChangeDetectionMixin from "../../mixins/localeChangeDetectionMixins";
import roleMixins from "../../mixins/roleMixins";

import { mapGetters } from "vuex";

import AsTitle from "@/components/Elements/AsTitle.vue";
import AsContainer from "@/components/Containers/AsContainer.vue";
import AsModal from "@/components/Modals/AsModal.vue";
import AsConfirmModal from "@/components/Modals/AsConfirmModal.vue";

import AuditDataList from "@/components/FicheBu/AuditDataList.vue";
import AuditDataForm from "@/components/FicheBu/AuditDataForm.vue";

import Button from "primevue/button";
import ProgressBar from "primevue/progressbar";

import { getAuditDatas, saveAuditData, deleteAuditData } from "../../services/auditDataServiceApi";
import entreprisesServiceApi from "../../services/entreprisesServiceApi";
import apiEventTypes from "../../constantes/apiEventTypes";

import moment from "moment"

export default {
    name: "AuditDataManagement",
    components: {
        AsTitle,
        AsContainer,
        AsModal,
        AsConfirmModal,
        AuditDataList,
        AuditDataForm,
        Button,
        ProgressBar,
    },
    data() {
        return {
            isAuditDataLoading: true,
            isSending: false,
            showAuditDataForm: false,
            currentAuditDataKey: 0,
            currentAuditData: { id: 0, },
            auditDatas: [],
            entreprises: [],
            auditDataToDeleteId: undefined,
            showDeleteAuditDataModal: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
    },
    mixins: [localeChangeDetectionMixin, roleMixins],
    beforeMount() {
        if (!this.isAdmin) {
            this.$router.push("/")
        } else {
            this.fetchData()
        }
    },
    methods: {
        async fetchData() {
            this.entreprises = await entreprisesServiceApi.getEntreprises(true)
            this._fetchAuditDatas()
        },
        showModalAuditDataForm() {
            this.currentAuditDataKey = Math.random();
            this.currentAuditData = { id: 0, idEntreprise: 0, value: 0 }
            this.showAuditDataForm = true
        },
        closeModalAuditDataForm() {
            this.showAuditDataForm = false
        },
        onShowDeleteAuditDataModal(auditDataId) {
            this.auditDataToDeleteId = auditDataId;
            this.showDeleteAuditDataModal = true;
        },
        deleteAuditDataCancel() {
            this.auditDataToDeleteId = undefined;
            this.showDeleteAuditDataModal = false;
        },
        async editAuditData(auditData) {
            this.currentAuditDataKey = Math.random();
            this.currentAuditData = { ...auditData }
            this.showAuditDataForm = true
        },
        async saveAuditData(data) {
            this.isSending = true;
            const savedAuditData = await saveAuditData(data)
            this.isSending = false
            if (savedAuditData) {
                this.showAuditDataForm = false
                const auditDatas = [...this.auditDatas]
                const indexOf = auditDatas.findIndex(e => e.id === savedAuditData.id)
                indexOf >= 0 ? auditDatas.splice(indexOf, 1, savedAuditData) : auditDatas.push(savedAuditData)
                this.auditDatas = auditDatas
                this._sortAuditDatas()
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_title"),
                            message: this.$t("popup_messages.success_created_message"),
                        },
                    })
                );
            } else {
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_ERROR, {
                        detail: {
                            title: this.$t("popup_messages.default_error_title"),
                            message: this.$t("popup_messages.default_error_message"),
                        },
                    })
                );
            }
        },
        async deleteAuditData() {
            if (!this.auditDataToDeleteId) { return }
            const result = await deleteAuditData(this.auditDataToDeleteId);
            if (result) {
                const newList = [...this.auditDatas];
                const indexOf = newList.findIndex((e) => e.id === this.auditDataToDeleteId);
                newList.splice(indexOf, 1);
                this.auditDatas = newList;
                this.deleteAuditDataCancel()
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_delete_title"),
                            message: this.$t("popup_messages.success_delete_message"),
                        },
                    })
                );
            }
        },
        async _fetchAuditDatas() {
            this.isAuditDataLoading = true
            const auditDatas = await getAuditDatas()
            this.auditDatas = auditDatas
            this._sortAuditDatas()
            this.isAuditDataLoading = false
        },

        _sortAuditDatas() {
            this.auditDatas.sort((a, b) => {
                const aBu = this.entreprises.find(e => e.id === a.idEntreprise)
                const bBu = this.entreprises.find(e => e.id === b.idEntreprise)
                return `${aBu.nom ?? ''}`.localeCompare(`${bBu.nom ?? ''}`) || b.year - a.year
            })
        }
    },
};
</script>

<style lang="scss">
#fichebu-audit-data-management {
    .p-datatable .p-datatable-tbody>tr>td {
        padding: 0rem 1rem !important;
    }
}
</style>
